module.exports = __webpack_public_path__ + "static/media/__investment.915b2f9e.svg";